<template>
  <router-view />
</template>

<script>
export default {
  name: 'Parent'
}
</script>
